import { CSSProperties } from 'react'

import styles from './TimesTable4x4.module.css'

interface Props {
  className?: string
  style?: CSSProperties
  value: string
  alignment?: 'horizontal' | 'vertical'
}

const COLORS = {
  '1': 'bg-orange-dark',
  '2': 'bg-pink-logo',
  '3': 'bg-purple',
  '4': 'bg-blue-logo',
}

const CellHeading = ({ className, style, value, alignment = 'horizontal' }: Props): React.ReactElement => {
  const alignmentClass =
    alignment === 'horizontal'
      ? `${styles['times-table-cell-width']} h-6 rounded-tl rounded-tr`
      : `w-6 ${styles['times-table-cell-height']} rounded-tl rounded-bl`
  return (
    <div
      className={`flex justify-center items-center ${COLORS[value as keyof typeof COLORS]} ${alignmentClass} ${
        className || ''
      }`}
      style={style}
    >
      <span className="text-white font-semibold text-xxs leading-4">{value}</span>
    </div>
  )
}

export default CellHeading
